module.exports = __webpack_public_path__ + "img/am.dfe2bd05.svg";